import { DRIFT_SITE_CONCIERGE_MEETINGS_MEASURES } from 'cube/constants'

import { CubeQuery } from '@driftt/dds.reports'

export const SiteConciergeMeetingsQuery: CubeQuery = {
  name: 'SiteConciergeMeetingsQuery',
  queryName: 'SiteConciergeMeetingsQuery',
  query: {
    measures: [
      DRIFT_SITE_CONCIERGE_MEETINGS_MEASURES.COUNT_SC_LOADS,
      DRIFT_SITE_CONCIERGE_MEETINGS_MEASURES.COUNT_MEETING_APP_LOADS,
      DRIFT_SITE_CONCIERGE_MEETINGS_MEASURES.COUNT_MEETING_BUTTON_CLICKS,
    ],
  },
}
